import { memo } from "react";

export const Loader = memo(
  ({ className, htmlFor, style, message, children, ...rest }) => {
    return null;
  }
);
